import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import { numberWithComma } from 'utils/number';

export default function BloodGlocoseDialogExerciseTable(props) {
  const {
    data,
  } = props;

  const {
    bldsugr_graph_list = [],
    // bld_sugr_time,
    // bld_sugr_value,
    // max_bld_sugr_yn,
    postprand2h_max_bldsugr_time,
    postprand2h_max_bldsugr_time_zone_tp_cd,
    bldsugr_before_meal,
    postprand2h_max_bldsugr,
    postprand2h_bldsugr,
    postprand2h_bldsugr_rise_w,
    postprand2h_bldsugr_tp,
    postprand_abnrml_bldsugr_min,
    main_food_list = [],
    // intaken_time,
    // main_food_nm,
    // main_food_cal,
    total_intaken_cal,
    carbo_rate,
    protein_rate,
    fat_rate,
    postprand_active_time,
    postprand_step_cnt,
    postprand_burn_cal,
    bolus_cnt,
    bolus_amt,
    bolus_time,
  } = data;

  return (
    <table>
      <tbody>
        <tr>
          <th>
            <div>
              {T('식후 활동시간')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} 분', postprand_active_time)}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('식후 활동걸음수')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} 보', numberWithComma(postprand_step_cnt))}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('식후 소모칼로리')}
            </div>
          </th>
          <td>
            <div>
              {T('{0} kcal', postprand_burn_cal)}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
